export default __webpack_public_path__ + "static/shopi1-1d504765e59af57a0913b6ac65e21d40.jpg";